import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import useAuth from "../../../../../hooks/useAuth";
import "../../AccountDetails.css";
import { COMPANY_LOGO_BASE_URL } from "../../../../../config/apiConfig";
import {
  ensureProtocol,
  formatBoldText,
  getKsCompanyName,
  getTaggedFirstKsCompany,
  numberWithCommas,
  stripUrl,
  transformResultsToCompProfileData,
  truncateDescription,
} from "../../../../../services/commonService";
import { useUser } from "../../../../../context/UserContext";
import RenderHtmlFormattedText from "../../../../HtmlElements/RenderHtmlFormattedText";
import CompanyPrimaryInfoSkeleton from "../../../skeletons/companyPrimaryInfoSkeleton/companyPrimaryInfoSkeleton";
import { Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";
import KeyFinancials from "../../../Competitors/KeyFinancials";
import BarGraphSkeleton from "../../../skeletons/barGraphSkeleton/barGraphSkeleton";

export default function CompetitorBanner({
  companyOverview,
  handleTabChange = { handleTabChange },
  competitorInfo,
}) {
  const { clientName, competitorName } = useParams();
  const [companyOverviewData, setCopmanyOverViewData] = useState([]);
  useAuth();
  const [account, setAccount] = useState([]);
  const [company_banner_path, setCompanyBannerpath] = useState("");
  const [overview_text, setOverviewText] = useState("");
  const [displayCompetitorName, setDisplayCompetitorName] = useState("");

  useEffect(() => {
    const storedData = localStorage.getItem("localStorageCompetitorInfo");

    if (storedData) {
      const parsed = JSON.parse(storedData);

      setDisplayCompetitorName(
        parsed?.competitor_display_name || parsed?.competitor_name || ""
      );
    }
  }, []);
  const [showDescriptionModal, setShowModal] = useState(false);
  const [isBannerLoading, setBannerLoading] = useState(false); // Loading state for banner
  const [isLogoLoading, setLogoLoading] = useState(true); // Loading state for logo
  const [keyFinancialsDataAvailable, setKeyFinancialsDataAvailable] =
    useState(true);
  const [ksCompanyName, setKsCompanyName] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setKeyFinancialsDataAvailable(true);
  }, []);

  useEffect(() => {
    setCopmanyOverViewData(companyOverview?.[0]);
  }, [companyOverview]);

  useEffect(() => {
    const fetchKsCompanyName = async () => {
      // const ksCompanyCode = competitorInfo?.ks_companies?.[0] ?? "";
      const ksCompanyCode = getTaggedFirstKsCompany(competitorInfo);

      const name = await getKsCompanyName(ksCompanyCode);
      setKsCompanyName(name);
    };

    fetchKsCompanyName();
  }, [competitorInfo]);

  return (
    <>
      {
        // companyOverviewData?.response?.company_overview?.description ? (
        // <BarGraphSkeleton />
        // ) :
        <div className="generic-take-space-child mb-2 p-2">
          <div
            className={`custom_card_block p-0 ${
              keyFinancialsDataAvailable ? "min_height_425" : ""
            }`}
          >
            <div className="company_overview_wrapper">
              <>
                <div className="top_img">
                  <>
                    {/* <div className="baseSkeleton img-banner-container"></div> */}
                    {/* Loading skeleton for banner */}
                    <img
                      src={`/img/company_images/company_background_image.png`}
                      className={`image_block`}
                      alt=""
                      aria-label="comapny-banner-img"
                      // /onLoad={() => {}} // Set loading state to false when image loads
                    />
                  </>
                  <div className="company_name_round">
                    <>
                      <div className="baseSkeleton img-logo-banner-container"></div>
                      {/* {isLogoLoading && (
                      <div className="baseSkeleton img-logo-banner-container"></div>
                    )}{" "} */}
                      {/* Loading skeleton for logo */}
                      <img
                        // src={`${
                        //   competitorName === "Tailored Chemical Products"
                        //     ? "/img/company_images/tailored_chemical_products_inc_logo.jpg"
                        //     : competitorName === "Cell Signaling Technology, Inc."
                        //     ? "/img/company_images/cell-signal-logo.jpeg"
                        //     : "/img/company_images/tailored_chemical_products_inc_logo.jpg"
                        // }`}
                        src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                          ksCompanyName?.length > 0
                            ? ksCompanyName
                            : (displayCompetitorName || competitorName)
                        )}`}
                        alt=""
                        aria-label="comapny logo img"
                        className={`company_logo ${
                          isLogoLoading ? "hidden" : ""
                        }`}
                        onLoad={() => {}} // Set loading state to false when image loads
                      />
                    </>
                  </div>
                </div>
                <div className="compnay_info_wrapper">
                  {/* <h5 className="company_name">{competitorName ?? ""}</h5> */}
                  <h5 className="company_name">
                    {displayCompetitorName || competitorName || ""}
                  </h5>

                  <div>
                    {/* <RenderHtmlFormattedText
                      htmlContent={
                        companyOverviewData?.response?.company_overview
                          ?.description ??
                        `Founded in 1977, ${
                          competitorName ?? "Tailored Chemical Products"
                        } is a leading mid-sized manufacturer of adhesives based in Hickory, North Carolina. The company that began as a small adhesives manufacturer in a 4,000 square foot facility, has now grown to four strategically located production centers in North Carolina, giving us a total of 325,000 square feet of manufacturing space. They manufacture a full line of hot melts, water-based glues, emulsion polymers, mastics, urea and synthetic resins and other specialty chemicals for any industrial application. If they don't already make the adhesive you're seeking, they have the in-house expertise to formulate an adhesive "Tailored" to your needs. ${
                          competitorName ?? "Tailored Chemical Products"
                        } is a company committed to customer satisfaction and versatility in product design. They do not have the attitude of "one size fits all." Rather, they exhibit a willingness that is unparalleled in the industry to "think outside the box" - to adapt new or improved adhesive technologies and ideas into every product they manufacture. `
                      }
                    /> */}
                    {/* <div className="company_info">
                      {formatBoldText(
                        <ParsedTextWithLinks
                          text={
                            companyOverviewData?.response?.company_overview
                              ?.description ??
                            `Founded in , ${
                              competitorName ?? ""
                            } is a leading mid-sized manufacturer of adhesives based in Hickory, North Carolina. The company that began as a small adhesives manufacturer in a 4,000 square foot facility, has now grown to four strategically located production centers in North Carolina, giving us a total of 325,000 square feet of manufacturing space. They manufacture a full line of hot melts, water-based glues, emulsion polymers, mastics, urea and synthetic resins and other specialty chemicals for any industrial application. If they don't already make the adhesive you're seeking, they have the in-house expertise to formulate an adhesive "Tailored" to your needs. ${
                              competitorName ?? ""
                            } is a company committed to customer satisfaction and versatility in product design. They do not have the attitude of "one size fits all." Rather, they exhibit a willingness that is unparalleled in the industry to "think outside the box" - to adapt new or improved adhesive technologies and ideas into every product they manufacture. `
                          }
                        />
                      )}
                    </div> */}

                    <div
                      className={`company_info company_description ${
                        !isExpanded ? "line-clamp-3" : ""
                      }`}
                      onClick={() => setIsExpanded((prev) => !prev)}
                      style={{ cursor: "pointer" }}
                    >
                      {formatBoldText(
                        <ParsedTextWithLinks
                          text={
                            companyOverviewData?.response?.company_overview
                              ?.description ??
                            `Founded in , ${
                              competitorName ?? ""
                            } is a leading mid-sized manufacturer...`
                          }
                        />
                      )}
                    </div>

                    {/* {
                    <Link onClick={() => {}} className="read-more-button">
                      <span className="show_more">
                        <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                      </span>
                    </Link>
                  } */}
                  </div>
                </div>

                <div className="compnay_subinfo_wrapper">
                  <ul className="company_list">
                    {
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              {" "}
                              <b>
                                Founded Year:{" "}
                                {companyOverviewData?.response?.quick_facts
                                  ?.founded?.value ?? ""}
                              </b>{" "}
                              <br />
                              {""}
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back blue_icon">
                            <img
                              src="/img/icons/overview/rocket.png"
                              className="img_icons_overview"
                            />
                          </p>
                        </OverlayTrigger>
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "18.85px",
                            color: "00000099",
                          }}
                        >
                          {companyOverviewData?.response?.quick_facts?.founded
                            ?.value ?? ""}
                        </span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              {" "}
                              <b>Founded Year: </b> <br />{" "}
                            </Tooltip>
                          }
                        >
                          <p className="info_company"></p>
                        </OverlayTrigger>
                      </li>
                    }

                    {
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>
                                Industry :{" "}
                                {companyOverviewData?.response?.quick_facts
                                  ?.industry?.value ?? ""}
                              </b>{" "}
                              <br />
                            </Tooltip>
                          }
                        >
                          <div className="icon_with_back green_icon">
                            <img
                              src="/img/icons/overview/building.png"
                              className="img_icons_overview"
                            />
                          </div>
                        </OverlayTrigger>
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "18.85px",
                            color: "00000099",
                          }}
                        >
                          {companyOverviewData?.response?.quick_facts?.industry
                            ?.value ?? ""}
                        </span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Industry : </b> <br />
                            </Tooltip>
                          }
                        >
                          <div className="info_company"> </div>
                        </OverlayTrigger>
                      </li>
                    }

                    {
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>
                                Employees:{" "}
                                {companyOverviewData?.response?.quick_facts
                                  ?.employees?.value ?? ""}
                              </b>{" "}
                              <br />
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back magenta_icon">
                            <img
                              src="/img/icons/overview/Union.png"
                              className="img_icons_overview"
                              width="18"
                            />
                          </p>
                        </OverlayTrigger>
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "18.85px",
                            color: "00000099",
                          }}
                        >
                          {companyOverviewData?.response?.quick_facts?.employees
                            ?.value ?? ""}
                        </span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>
                                Employees:{" "}
                                {companyOverviewData?.response?.quick_facts
                                  ?.employees?.value ?? ""}
                              </b>{" "}
                              <br />
                            </Tooltip>
                          }
                        >
                          <p className="info_company"></p>
                        </OverlayTrigger>
                      </li>
                    }

                    {
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>
                                {companyOverviewData?.response?.quick_facts
                                  ?.headquarters?.value ?? ""}
                              </b>{" "}
                              <br />{" "}
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back blue_icon">
                            <img
                              src="/img/icons/overview/marker.png"
                              className="img_icons_overview"
                            />
                          </p>
                        </OverlayTrigger>
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "18.85px",
                            color: "00000099",
                          }}
                        >
                          {/* {companyOverviewData?.response?.quick_facts
                          ?.headquarters?.value ??
                          ""} */}
                          {companyOverviewData?.response?.quick_facts
                            ?.headquarters?.value ?? ""}
                        </span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Headquarters (Country):</b> <br />{" "}
                            </Tooltip>
                          }
                        >
                          <p className="info_company"></p>
                        </OverlayTrigger>
                      </li>
                    }

                    {
                      <li className="company_sublist">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              {" "}
                              <b>
                                Organization Website :{" "}
                                {companyOverviewData?.response?.quick_facts
                                  ?.website?.value ?? ""}
                              </b>{" "}
                            </Tooltip>
                          }
                        >
                          <p className="icon_with_back grey_icon">
                            <img
                              src="/img/icons/overview/globe.png"
                              className="img_icons_overview"
                            />
                          </p>
                        </OverlayTrigger>
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "18.85px",
                            color: "00000099",
                          }}
                        >
                          {companyOverviewData?.response?.quick_facts?.website
                            ?.value ?? ""}
                        </span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              <b>Organization Website :</b>{" "}
                            </Tooltip>
                          }
                        >
                          <p className="info_company">
                            <a
                              href={ensureProtocol("")}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="compnay_link"
                            >
                              {stripUrl("")}
                            </a>
                          </p>
                        </OverlayTrigger>
                      </li>
                    }
                    <li className="company_sublist"> </li>
                  </ul>
                </div>
              </>
            </div>
          </div>
        </div>
      }

      <KeyFinancials
        className="key_financials"
        handleTabChange={handleTabChange}
        competitorInfo={competitorInfo}
        setKeyFinancialsDataAvailable={setKeyFinancialsDataAvailable}
      />
    </>
  );
}
